import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { User } from '../../../shared/data/user';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'ngx-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
  @Input() id: number;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  urlEpreuve:File = null;
  civilite;
  /*imagePreviewPubli:any;
  usernam;
  emaile;
  plainPass;
  nome;
  prenome;
  adress;
  civility;
  telephon;
  photo;
  dateNaissanc;
  date;
  month;
  year;
  
  day;
  heure;
  minute;
  password; */

  model;

  user = new User;
  users:any =[];
  hideButon = false;
  hideLoader =true;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'designation',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  permissions: any[];

  // fichierName;
  constructor(protected dialogRef: NbDialogRef<EditUserComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr:NbToastrService) {
    
   }

  ngOnInit() {

    if(this.id !== 0)
    this.getUser();

    this.civilite = ["mme","mlle","mr"];
  }

  getUser(){

    this.apiService.getOneUserProvider(this.id).subscribe(data =>{
      // this.user.push(data);
      this.user = plainToClass( User, data as object);
      this.model = this.user.converBirthdayToNgbDateStruct;

      this.apiService.getAllPermissionsProvider().subscribe(data =>{

        this.permissions = data as any[];
        let permisssionSelect = [];

        if(this.user.permissions !== null && this.user.permissions !== undefined) {

          this.user.permissions.forEach( elem => {

            const indexitem = this.permissions.findIndex( item => item.value === elem)

            if(indexitem > -1)
            permisssionSelect.push( this.permissions[indexitem])

          })

        }
       
  
        this.selectedItems = permisssionSelect;
        // console.log(this.model);
  
      })

      
    })

  }


  handleFileInput(event) {
    this.user.selectedPhotoFile = event.target.files[0];
    // this.fichierName = this.selectedFile.name;
  
      if ( /\.(jpg||jpeg||png)$/i.test(this.user.selectedPhotoFile.name) && this.user.selectedPhotoFile.size <= 2000000){
        // this.imagePreviewPubli = event.target.files[0];
      } else {
       
        this.toastr.danger( "vous devez choisir les fichiers jpg, jpeg ou png");

      }
    
  }


  onSubmit(){
    
    
    this.hideButon = true;
    this.hideLoader = false;

    /*  this.date = new Date(this.dateNaissanc);
    this.year =  this.date.getFullYear();
    this.month =  this.date.getMonth()+1;
    this.day =  this.date.getDate();
    this.heure = this.date.getHours();
    this.minute =this.date.getMinutes(); */

    this.user.date_naissance = this.model;
 
    if(this.id !== 0) {

      this.apiService.updateUserProvider(this.user).subscribe ((data) => {

        const user = plainToClass( User, data as object);
        console.log(data);
        this.toastr.success( "modifié", user.username);
        this.dialogRef.close();
        this.sendeurService.sendUserEvent(5);

      }, (err) =>{
        this.hideButon = false;
        this.toastr.danger( "echec de modification de l'utilisateur, vérifiez que tous les champs sont bien remplis");
        this.hideLoader = true;
        console.log(err);
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }

      }); 

    } else {

      this.apiService.createUserProvider(this.user).subscribe ((data) => {
        const user = plainToClass( User, data as object);
        console.log(data);
        this.toastr.success( "crée", user.username);
        this.dialogRef.close();
        this.sendeurService.sendUserEvent(5);

      }, (err) =>{
        this.hideButon = false;
        this.toastr.danger( "echec de modification de l'utilisateur, vérifiez que tous les champs sont bien remplis");
        this.hideLoader = true;
        console.log(err);
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }

      });
      
    }


  }

  onItemSelect(item: any){

    /* let itemIndex: number;
    itemIndex = this.article.categories.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.article.categories.splice(itemIndex, 1); */
    this.user.permissions =  this.selectedItems ;

  }


  onItemDeSelect(item: any){

    /* let itemIndex: number;
    itemIndex = this.article.categories.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.article.categories.splice(itemIndex, 1); */
    this.user.permissions =  this.selectedItems ;

  }

  onSelectAll(items: any) {
    this.user.permissions =  this.permissions ;
  }

  onDeSelectAll($event){
    this.user.permissions =  this.selectedItems ;
  }

  onUnSelectAll(){
    this.user.permissions =  [];
  }

  onDropDownClose($event){
    
  }


  cancel(){
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }

}
